import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-grow-1 d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_audio_player = _resolveComponent("audio-player")!
  const _component_wiki_map = _resolveComponent("wiki-map")!
  const _component_Authorized = _resolveComponent("Authorized")!
  const _component_tv_selector = _resolveComponent("tv-selector")!
  const _component_MagicRemoteJoystick = _resolveComponent("MagicRemoteJoystick")!
  const _component_Notifications = _resolveComponent("Notifications")!

  return (_openBlock(), _createElementBlock("main", {
    id: "app",
    class: "lead min-vh-100 bg-image-full",
    style: _normalizeStyle(
      _ctx.theme !== 'a11y'
        ? `background-image: url(${_ctx.$getImage('main-bg.png', 'backgrounds')})`
        : 'background: #212121'
    )
  }, [
    _createVNode(_component_Authorized, null, {
      default: _withCtx(() => [
        _createVNode(_component_wiki_map, null, {
          default: _withCtx(() => [
            _createVNode(_component_audio_player, {
              onSendNewCommand: _ctx.sendNewCommand,
              ref: "audio-player"
            }, {
              default: _withCtx(() => [
                _createElementVNode("main", _hoisted_1, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout), {
                    onOpenAudioPlauer: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPlayAudio())),
                    onSlidebarOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAudioPlayers())),
                    onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startconf(), _ctx.myVirtualRooma(), _ctx.gpsCoordsDefinition())),
                    onTvconnect: _ctx.sendNewCommand,
                    onTvlist: _ctx.loadAvailableTvs
                  }, null, 40, ["onTvconnect", "onTvlist"]))
                ])
              ]),
              _: 1
            }, 8, ["onSendNewCommand"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_tv_selector, {
      ref: "TvSelector",
      televisions: _ctx.available_tvs,
      onSelectedTv: _ctx.wsSelectedTv
    }, null, 8, ["televisions", "onSelectedTv"]),
    _createVNode(_component_MagicRemoteJoystick, {
      ref: "MagicRemoteJoystick",
      onSendNewCommand: _ctx.sendNewCommand
    }, null, 8, ["onSendNewCommand"]),
    _createVNode(_component_Notifications)
  ], 4))
}